import React from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import Section from "components/ui/Section";
import PaymentSummaryCard from "components/salesPayment/PaymentSummaryCard";
import PaymentMethodList from "components/salesPayment/PaymentMethodList";
import { useHomePaymentQuery } from "pages/Sales/_hooks/useHomePaymentQuery";

const LABEL: Record<string, string> = {
  daily: "일간 매출",
  weekly: "주간 매출",
  monthly: "월간 매출",
};

export const PeriodInfo = () => {
  const navigate = useNavigate();
  const { query, periodType } = useHomePaymentQuery();
  const { branchUseYn, seqPartnerBranch } = useSelector((s: any) => s.partner);
  const { data, isLoading, isError, refetch } = query;

  const goDetail = () => {
    const isBranch = branchUseYn === "Y" && seqPartnerBranch === 0;
    navigate(isBranch ? `/sales/branch/${periodType}` : `/sales/${periodType}`);
  };

  return (
    <Section
      isLoading={isLoading}
      isError={isError}
      onRefresh={() => refetch()}
      onClick={undefined}
    >
      {data ? (
        <PaymentSummaryCard
          label={LABEL[periodType]}
          totalAmount={data.totalAmount}
          series={data.series}
          onTotalClick={goDetail}
        >
          <PaymentMethodList
            methods={data.paymentMethods}
            refund={data.refund}
          />
        </PaymentSummaryCard>
      ) : null}
    </Section>
  );
};

export default PeriodInfo;
